import {Component, Input, OnInit, OnChanges, SimpleChanges}    from '@angular/core';
import {HttpEventType, HttpResponse} from '@angular/common/http';

import {StorageS} from '../../service/storage';

@Component({
	           moduleId   : module.id,
	           selector   : 'app-upload-image',
	           templateUrl: 'upload-images.component.html'
           })

export class UploadFilesComponent implements OnInit, OnChanges  {
	@Input() model: any;
	@Input() baseUrl: any;
	public showPreview: boolean  = false;
	public showVideoPreview: boolean  = false;
	public showBrochurePreview: boolean  = false;
	selectedFiles: FileList;
	selectedVideo: FileList;
	selectedBrochure: FileList;
	progressInfos                = [];
	isUploading: boolean = false;
	message                      = '';
	serverPath                   = 'https://kadaikoditech.com:4000/uploads/';
	public previousIndex: number = 0;
	public headImg: any;

	constructor(private storageS: StorageS){ }
// fixZFUrls() {
//   if (!this.model?.zf || !Array.isArray(this.model.zf)) {
//     console.log('ZF not available or not array:', this.model?.zf);
//     return;
//   }

//   console.log('ZF BEFORE FIX:', JSON.parse(JSON.stringify(this.model.zf)));

//   this.model.zf.forEach((zf, index) => {
//     if (!zf?.nm || !zf?.url) return;

//     // ✅ FULL URL → DO NOTHING
//     if (/^https?:\/\//i.test(zf.url)) {
//       console.log(`ZF[${index}] full URL, unchanged →`, zf.url);
//       return;
//     }

//     // normalize
//     const cleanUrl = zf.url.replace(/^\/+/, '').replace(/\/+$/, '');

//     if (cleanUrl === 'uploads/user') {
//       const fixed = `${this.serverPath}user/${zf.nm}`;
//       console.log(`ZF[${index}] fixed →`, fixed);
//       zf.url = fixed;
//     }
//   });

//   console.log('ZF AFTER FIX:', JSON.parse(JSON.stringify(this.model.zf)));
// }

normalizeAndFixZF(zf: any): any[] {
  // ✅ already an array → just fix URLs
  if (Array.isArray(zf)) {
    return zf.map(item => {
      if (!item?.nm) return item;

      if (item.url && /^https?:\/\//i.test(item.url)) {
        return item;
      }

      return {
        ...item,
        url: `https://kadaikoditech.com:4000/uploads/user/${item.nm}`
      };
    });
  }

  if (!zf) return [];

  let raw = zf;
  let guard = 0;

  while (typeof raw === 'string' && guard < 10) {
    try {
      // remove wrapping quotes
      if (
        (raw.startsWith('"') && raw.endsWith('"')) ||
        (raw.startsWith("'") && raw.endsWith("'"))
      ) {
        raw = raw.slice(1, -1);
      }

      // clean excessive escaping
      raw = raw
        .replace(/\\\\+"/g, '"')
        .replace(/\\"/g, '"')
        .replace(/\\\\/g, '\\');

      raw = JSON.parse(raw);
    } catch {
      break;
    }
    guard++;
  }

  if (!Array.isArray(raw)) {
    return [];
  }

  return raw.map(item => {
    if (!item?.nm) return item;

    if (item.url && /^https?:\/\//i.test(item.url)) {
      return item;
    }

    return {
      ...item,
      url: `https://kadaikoditech.com:4000/uploads/user/${item.nm}`
    };
  });
}






ngOnChanges(changes: SimpleChanges): void {
  if (changes['model']) {
    console.log('ZF RECEIVED IN CHILD:', this.model?.zf);
  }

  if (this.model?.zf !== undefined && this.model?.zf !== null) {
    this.model.zf = this.normalizeAndFixZF(this.model.zf);

    if (this.model.zf.length) {
      this.showPreview = true;
      this.selectImage(0);
    }
  }
}



ngOnInit(): void {
  if (this.model?.zf) {
    this.model.zf = this.normalizeAndFixZF(this.model.zf);

    if (this.model.zf.length) {
      this.showPreview = true;
      this.selectImage(0);
    }
  }

  if (this.model?.video) this.showVideoPreview = true;
  if (this.model?.brochure) this.showBrochurePreview = true;
}

	getServerPath(url: string) {
  if (!url) return '';

  // ✅ Already full URL → return as-is
  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  // ✅ Relative path → prefix
  return this.serverPath + url.replace(/^\/+/, '');
}



buildFiles() {
    //console.log("hello build" + this.model.zf);
    this.storageS.getFiles(this.baseUrl).subscribe((response) => {
        if (this.model.zf === null || this.model.zf === undefined) {
  this.model.zf = [];
}

        if (response && response.length) {
            let isFirst = true;

            for (let file of this.progressInfos || []) {
                if (file && file.name) {
                    // Convert name to lowercase and replace spaces with underscores
                    const formattedName = file.name.toLowerCase().replace(/\s+/g, "_");

                    let isExist = false;
                    for (let zf of this.model.zf || []) {
                        if (zf && zf.nm === formattedName) {
                            isExist = true;
                            break;
                        }
                    }

                    if (!isExist) {
                        this.model.zf.push({
                            nm: formattedName,
                            url: `${this.serverPath}${this.baseUrl}/${formattedName}`,
                            a: isFirst ? 1 : 0
                        });
                        this.showPreview = true;
                        if (isFirst) {
                            this.headImg = `${this.serverPath}${this.baseUrl}/${formattedName}`;
                            console.log(this.headImg);
                        }
                        isFirst = false;
                    }
                }
            }
        }

        console.log(this.model.zf);
    }, error => {
        console.log(error);
    });
}


	removeImage(index){
		this.model.zf.splice(index, 1);
		if(this.model.zf.length){
			this.selectImage(0);
			this.showPreview = true;
		} else{
			this.showPreview = false;
		}
	}

	selectImage(index){
		this.model.zf[this.previousIndex].a = 0;
		this.previousIndex                  = index;
		this.model.zf[index].a              = 1;
		this.headImg                        = this.model.zf[index].url;
	}


	selectFiles(event): void{
		this.progressInfos = [];

		const files = event.target.files;
		let isImage = true;

		for(let i = 0; i < files.length; i++){
			const fileType = files.item(i).type;
			if(fileType.match('image.*') || fileType.match('video.*')){
				continue;
			} else{
				isImage = false;
				alert('invalid format!');
				break;
			}
		}

		if(isImage){
			this.selectedFiles = event.target.files;
			this.uploadFiles();
		} else{
			this.selectedFiles          = undefined;
			event.srcElement.percentage = null;
		}
	}

	selectVideo(event): void{
		this.progressInfos = [];

		const files = event.target.files;
		let isVideo = true;

		for(let i = 0; i < files.length; i++){
			if(files.item(i).type.match('video.*')){
				continue;
			} else{
				isVideo = false;
				alert('invalid format!');
				break;
			}
		}

		if(isVideo){
			this.selectedVideo = event.target.files;
			this.uploadVideo();
		} else{
			this.selectedFiles          = undefined;
			event.srcElement.percentage = null;
		}
	}

	selectBrochure(event): void{
		this.progressInfos = [];

		const files = event.target.files;
		let isPDF = true;

		for(let i = 0; i < files.length; i++){
			if(files.item(i).type.match('application/pdf')){
				continue;
			} else{
				isPDF = false;
				alert('invalid format!');
				break;
			}
		}

		if(isPDF){
			this.selectedBrochure = event.target.files;
			this.uploadBrochure();
		} else{
			this.selectedBrochure          = undefined;
			event.srcElement.percentage = null;
		}
	}

	triggerInput(event){
		const element = event.currentTarget;
		element.querySelector('input').click();
	}

	async uploadFiles() {
		this.message = '';
		let promises = [];
	    this.isUploading = true; // Show uploading message
		// Loop through selected files
		for (let i = 0; i < this.selectedFiles.length; i++) {
			let file = this.selectedFiles[i];
	
			// Check file size (<= 100MB)
			if (file.size > 100 * 1024 * 1024) {
				alert(`File size exceeds 100MB: ${file.name}`);
				continue;  // Skip uploading this file
			}
	
			// If file is valid, push the upload to promises
			promises.push(this.upload(i, file));
		}
	
		// Wait for all valid files to be uploaded
		Promise.all(promises).then(() => {
			this.isUploading = false; // Hide uploading message
			this.buildFiles();
		});
	}
	

	async uploadVideo(){
		this.message = '';
		let promises = [];
		for(let i = 0; i < this.selectedVideo.length; i++){
			if(this.selectedVideo[i]){
				promises.push(await this.uploadVideoToServer(i, this.selectedVideo[i]));
			}
		}

		Promise.all(promises).then(()=>{
			this.showVideoPreview = true;
		})
		
	}

	async uploadBrochure(){
		this.message = '';
		let promises = [];
		for(let i = 0; i < this.selectedBrochure.length; i++){
			if(this.selectedBrochure[i]){
				promises.push(await this.uploadBrochureToServer(i, this.selectedBrochure[i]));
			}
		}

		Promise.all(promises).then(()=>{
			this.showBrochurePreview = true;
		})
		
	}

	upload(idx, file){
		return new Promise((resolve, reject)=>{
			this.progressInfos[idx] = {value: 0, name: file.name};
			this.storageS.pushFileToStorage(file, this.baseUrl).subscribe(event => {
				if(event.type === HttpEventType.UploadProgress){
					//this.progress.percentage = Math.round(100 * event.loaded / event.total);
				} else if(event instanceof HttpResponse){
					console.log('File is completely uploaded!');
					resolve(true);
				}
			});
		})
	}

	uploadVideoToServer(idx, file){
		return new Promise((resolve, reject)=>{
			this.progressInfos[idx] = {value: 0, name: file.name};
			this.storageS.pushVideoToStorage(file, this.baseUrl).subscribe(event => {
				if(event.type === HttpEventType.UploadProgress){
					//this.progress.percentage = Math.round(100 * event.loaded / event.total);
				} else if(event instanceof HttpResponse){
					this.model.video = event.body;
					resolve(true);
				}
			});
		})
	}

	uploadBrochureToServer(idx, file){
		return new Promise((resolve, reject)=>{
			this.progressInfos[idx] = {value: 0, name: file.name};
			this.storageS.pushBrochureToStorage(file, this.baseUrl).subscribe(event => {
				if(event.type === HttpEventType.UploadProgress){
					//this.progress.percentage = Math.round(100 * event.loaded / event.total);
				} else if(event instanceof HttpResponse){	
					console.log(event.body)	
					this.model.brochure = event.body;
					resolve(true);
				}
			});
		})
	}

	isImage(url: string): boolean {
		return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
	  }
	  
	isVideo(url: string): boolean {
		return /\.(mp4|webm|ogg|mov)$/i.test(url);
	  }
}
